// extracted by mini-css-extract-plugin
export default {"bubbleText":"BubbleText__bubbleText___tR3o3"};